import { helpers, maxLength, required, requiredIf } from '@vuelidate/validators'
import type { ITextOptions } from './useText.types'
import type { TInstance } from '@/components/Inputs/Composables/validators/validators.types'

export function useText(
  field: string,
  t: TInstance,
  options: ITextOptions,
) {
  return ({
    [`${field}`]: {
      ...((options.required || options.requiredIf) && {
        required: helpers.withMessage(
          () => t('formValidatorMessages.text.required'),
          options.requiredIf ? requiredIf(options.requiredIf) : required,
        ),
      }),
      maxLength: helpers.withMessage(
        () => t('formValidatorMessages.text.maxLength', { count: options.length }),
        maxLength(options.length),
      ),
    },
  })
}
